"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.obfuscateEmail = void 0;
const obfuscateEmail = (email) => {
    var _a;
    if (email && ~email.indexOf('@')) {
        const [emailName, domain] = email.split('@');
        let obfuscatedName;
        if (emailName.length === 1) {
            obfuscatedName = '*';
        }
        else if (emailName.length === 2) {
            obfuscatedName = `${emailName[0]}*`;
        }
        else {
            obfuscatedName = `${emailName[0]}${(_a = '*'.repeat) === null || _a === void 0 ? void 0 : _a.call('*', emailName.length - 2)}${emailName[emailName.length - 1]}`;
        }
        return `${obfuscatedName}@${domain}`;
    }
    else {
        return email;
    }
};
exports.obfuscateEmail = obfuscateEmail;
//# sourceMappingURL=email.js.map